import React from "react";
import ViewWorkflow from "./ViewWorkflow/ViewWorkflow";

const WorkflowPage = () => {
  return (
    <div>
      <ViewWorkflow />
    </div>
  );
};

export default WorkflowPage;
